<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/stucollect">留学汇总</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>地区统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="80px"
        size="small"
        class="query-form"
      >
        <el-form-item label="录入时间">
          <el-date-picker
            v-model="query.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="yearSearch()"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="缴费时间">
          <el-date-picker
            v-model="query.paytime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="payYearSearch()"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="this.getCollect()">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height: 20px"></div>
      <el-row :gutter="24" class="row">
        <el-col :span="12">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>Vip学生统计</span>
            </div>
            <div class="index-card" style="height: auto">
              <div id="Area" style="height: 560px"></div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card collectCard" shadow="always">
            <div class="clearfix" slot="header">
              <span>Vip学生统计</span>
            </div>
            <div class="index-card" style="height: auto">
              <div id="School" style="height: 860px"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/theme/macarons.js";
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {
        time: [],
        paytime: [],
      }, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
    };
  },
  methods: {
    //月份选择
    yearSearch() {
      if (this.query.time) {
        this.query.start = this.query.time[0];
        this.query.end = this.query.time[1];
      } else {
        this.query.start = "";
        this.query.end = "";
      }
      this.query.paystart = undefined;
      this.query.payend = undefined;
      this.query.paytime = [];
      this.getCollect();
    },
    //支付月份
    payYearSearch() {
      this.query.start = "";
      this.query.end = "";
      this.query.time = [];
      if (this.query.paytime) {
        this.query.paystart = this.query.paytime[0];
        this.query.payend = this.query.paytime[1];
      } else {
        this.query.paystart = "";
        this.query.payend = "";
      }
      this.getCollect();
    },
    //获取学校统计，地区统计
    getCollect() {
      //饼状图
      var link = url.getCollect("getareaindex");
      $.get(link, this.query, (data) => {
        //地区统计
        var areaChart = echarts.init(
          document.getElementById("Area"),
          "macarons"
        );
        // 绘制图表
        areaChart.setOption({
          title: {
            text: "省申请人数Top10",
            subtext: "数据来自Crm系统",
            x: "left",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)人申请",
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        });
      });
      //柱状图
      var link2 = url.getCollect("GetAreaAll");
      $.get(link2, this.query, (data) => {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(
          document.getElementById("School"),
          "macarons"
        );
        // 绘制图表
        myChart.setOption({
          title: {
            text: "省份汇总",
            subtext: "数据来自Crm系统",
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
          },
          yAxis: {
            type: "category",
            data: data.name.reverse(),
          },
          series: [
            {
              name: "申请人数",
              type: "bar",
              data: data.value.reverse(),
              label: {
                normal: {
                  show: true,
                  position: "inside",
                },
              },
            },
          ],
        });
      });
    },
  },
  created() {},
  mounted() {
    this.getCollect();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
